/**
 * @author rongodzhang
 * 单位转换
 */

export const emuToPt = emu => emu / 12700;

export const emuToCm = emu => emu / 360000;

export const emuToInch = emu => emu / 914400;

export const emuToAngle = emu => emu / 60000;

export const emuToPercent = emu => emu / 1000;

export const emuToAlpha = emu => emu / 100000;

export const ptToEmu = pt => pt * 12700;

export const cmToEmu = cm => cm * 360000;

export const inchToEmu = inch => inch * 914400;

export const angleToEmu = emu => emu * 60000;

export const percentToEmu = emu => emu * 1000;

export const alphaToEmu = emu => emu * 100000;

// PPT原始数据转换为UI显示使用的单位
export const emuToCanvas = emu => emu / EMU_CANVAS_SCALE;

export const canvasToEmu = canvas => canvas * EMU_CANVAS_SCALE;

export const canvasToPt = canvas => canvas / CANVAS_PT_SCALE;

export const ptToCanvas = pt => pt * CANVAS_PT_SCALE;

/**
 * 将厘米转换为英寸（1英寸 = 2.54厘米）
 */
export const cmToInch = cm => cm / 2.54;
/**
 * 点（pt）：将点转换为英寸（1英寸 = 72点，1 CSS 像素 = 96/72 英寸）
 */
export const ptToInch = pt => (pt * 72) / 96;
/**
 * 派卡（pc）：将派卡转换为英寸（1英寸 = 6派卡，1 CSS 像素 = 96/72 英寸）
 */
export const pcToInch = pc => (pc * 72) / 12 / 96;
/**
 * 像素（px）：将像素转换为英寸（1 CSS 像素 = 96/72 英寸）
 */
export const pxToInch = px => (px * 96) / 72;
/**
 * 将垂直像素每米数（DPM）转换为垂直像素每英寸数（DPI）
 * 1英寸等于0.0254米，所以需要用0.0254乘以DPM值
 */
export const dpmToInch = dpm => dpm * 0.0254;

export const inchToCm = inch => inch * 2.54;

/**
 * PPT 单位磅转为 px，基本是 1 : 1.333
 * @param {number} pt
 * @returns {number}
 */
const PX_IN_ONE_INCH = 96;
const PT_IN_ONE_INCH = 72;
export const PT_TO_REAL_PX_RATE = PX_IN_ONE_INCH / PT_IN_ONE_INCH;
export const ptToRealPx = pt => pt * PT_TO_REAL_PX_RATE;
export const pxToRealPt = px => px / PT_TO_REAL_PX_RATE;

/**
 * 百分比转数值
 * @param pc percent
 * @returns {number} number
 */
export const percentToNum = pc => pc / 100000;
export const numToPercent = num => num * 100000;

/**
 * pt px 转换
 * @param pt 字体磅 * 100
 * @returns {number} px
 */
export const ptToPx = pt => pt / 100;
export const pxToPt = px => px * 100;

export const EMU_CANVAS_SCALE = 6350;
export const CANVAS_PT_SCALE = 2;
export const EMU_PT_SCALE = 12700;

export function isNumberEqual(val1, val2, digits) {
    return Math.abs(val1 - val2) < digits;
}
/**
 * 将alpha通道值转换成对应的透明度百分比
 * @param {number} alpha 小数，alpha通道，单位不是emu
 */
export const alphaToOpacity = alpha => (1 - alpha) * 100;
/**
 * 将UI上的透明度百分比转换成图形、图片等可以接受的alpha通道，单位不是emu
 * @param {number} opacity UI上显示的透明度百分比
 */
export const opacityToAlpha = opacity => 1 - (opacity / 100);

/**
 * pt转cm，并按需保留小数
 * @param pt 磅
 * @param toFixed 保留几位小数
 */
export const ptToCm = (pt, toFixed) => {
    const fixedNumber = Math.pow(10, toFixed);
    return Math.round(emuToCm(ptToEmu(Number(pt))) * fixedNumber) / fixedNumber;
};

/**
 * cm转pt，并按需保留小数
 * @param cm 厘米
 * @param toFixed 保留几位小数
 */
export const cmToPt = (cm, toFixed) => {
    const fixedNumber = Math.pow(10, toFixed);
    return Math.round(emuToPt(cmToEmu(Number(cm))) * fixedNumber) / fixedNumber;
};
// 1倍值的情况下 1cm = 28px
// todo: 28这个计算是失精的，28.35更接近些，需要看下影响统一替换下
export const CM_TO_PX = 28;
/**
 * 将px转化为cm。style中存储的值是通过emuToCanvas算出来的
 */
export const convertPxToCm = (pxVal: number): number => Number(emuToCm(canvasToEmu(pxVal)).toFixed(4));

/**
 * 将cm转化为px。
 */
export const convertCmToPx = (cmVal: number): number => Number(emuToCanvas(cmToEmu(cmVal)).toFixed(2));

export const CM_TO_PT = 28.35;
export const SLIDE_CM_TO_PX = CM_TO_PT * 2;

// slide 中多倍行距值和 ppt 中多倍行距值的比例，这个比例是前辈们比对两边效果计算出来的一个经验值
export const PERCENT_LINE_HEIGHT_SLIDE_TO_PPT_RATIO = 1.2;

export enum EUnit {
    IN = 'in',
    CM = 'cm',
    MM = 'mm',
    PT = 'pt',
    PC = 'pc',
    PX = 'px',
}
